import { Base } from "./colors.base";
import { Families } from "./components/families/families";
import { Filters } from "./components/filters/filters";

export const Colors = Object.assign(Base, {
    Filters,
    Families
});
